import { useTranslation } from 'react-i18next';
import { ControlledMultiPickerWithCategory } from 'src/shared/components/form/controlledMultiPickerWithCategory';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getCountys } from 'src/shared/services/countyService';

type MemberAdvancedSearchCountyProps = {
  // När formuläret bara har län (municipalityCode ej show=true) visas en ren läns-väljare
  // utan kommun-nivå. isParent-noderna hamnar då i countyCode-filtret precis som annars.
  lanOnly?: boolean;
  // Etikett från formulärets heading för countyCode (faller tillbaka på standardtexten).
  label?: string;
};

export const MemberAdvancedSearchCounty = (props: MemberAdvancedSearchCountyProps = {}) => {
  const { lanOnly = false, label } = props;
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();

  return (
    <ControlledMultiPickerWithCategory
      name='countyCode'
      limitTags={2}
      componentWidth='100%'
      // Läns-varianten är en platt multiväljare utan kategori-rubriker.
      showCategory={!lanOnly}
      callback={(x) => ConsoleHelper.log(x)}
      fetchMethod={async () => {
        try {
          const result = await getCountys(0, 500, 'lan', 'asc');
          if (isMounted()) {
            const countyArray: any = [];
            result.data.results.forEach((county) => {
              if (lanOnly) {
                // Endast län: pusha läns-noden som valbart alternativ (isParent=true, name=länets namn),
                // utan kommuner. Hamnar i countyCode-filtret via getMemberSearchFilter.
                countyArray.push({
                  code: county.code,
                  parentName: county.name,
                  parentCode: county.code,
                  isParent: true,
                  name: county.name,
                });
                return;
              }

              // Län + kommun: läns-noden ("Hela X") som väljer allt inom länet, följt av alla kommuner.
              countyArray.push({
                code: county.code,
                parentName: county.name,
                parentCode: county.code,
                isParent: true,
                name: t('common:form.countyPickerAll', { region: county.name }),
              });
              if (county) {
                county.municipalities.forEach((muni) => {
                  // Pushar in alla kommuner
                  countyArray.push({
                    code: muni.code,
                    parentName: county.name,
                    parentCode: county.code,
                    isParent: false,
                    name: muni.name,
                  });
                });
              }
            });

            return countyArray;
          }
        } catch (e) {
          if (isMounted()) {
            ConsoleHelper.log(e);
          }
        }

        return [];
      }}
      label={label && label.length > 0 ? label : t('common:form.countyAndMunicipality')}
    />
  );
};
